import { postRequest } from "../../config/axiosConfig";
import { removeToken } from "../../utils/tokenUtils";

export const doAdminLogin = async ({ phone, password }) => {
  try {
    const response = await postRequest({
      url: process.env.REACT_APP_BASE_URL + "auth/admin/login",
      data: {
        mobile: phone,
        password,
      },
    });

    if (response?.status === 200) {
      return {
        success: true,
        data: response,
        message: "Logged In Successfully!",
      };
    } else {
      return {
        success: false,
        data: response,
      };
    }
  } catch (error) {
    return {
      success: false,
      data: null,
      message: "Invalid login attempt.",
    };
  }
};

export const doAdminLogout = async () => {
  try {
    const response = await postRequest({
      url: process.env.REACT_APP_BASE_URL + "auth/admin/logout",
    });

    if (response?.status === 200) {
      return {
        success: true,
        data: response,
        message: "Logged out Successfully!",
      };
    } else {
      return {
        success: false,
        data: response,
      };
    }
  } catch (error) {
    return {
      success: false,
      data: null,
      message: "Invalid logout attempt.",
    };
  }
};

export const getRefreshToken = async () => {
  try {
    const response = await postRequest({
      url: process.env.REACT_APP_BASE_URL + "auth/admin/refresh-token",
    });

    if (response?.status === 200) {
      return {
        success: true,
        data: response,
        message: "Refreshed token success",
      };
    } else {
      return {
        success: false,
        data: response,
      };
    }
  } catch (error) {
    return {
      success: false,
      data: null,
      message: "failed to get refresh token",
    };
  }
};
